import styled from 'styled-components';

const Grid = styled.div`
  display: grid;
  margin: 0;
  grid-gap: 30px;
  grid-template-columns: repeat(12, minmax(0, 1fr));

  @media (max-width: ${(props) => props.theme['media.tablet']}px) {
    grid-gap: 20px;
  }
`;

const GridCell = styled.div`
  width: auto;
  grid-column-end: span ${(props) => props.span.desktop};
  margin: 0;

  ${(props) => props.span.tablet && `
    @media (max-width: ${props.theme['media.tablet']}px) {
      grid-column-end: span ${props.span.tablet};
    }
  `}

  ${(props) => props.span.mobile && `
    @media (max-width: ${props.theme['media.mobile']}px) {
      grid-column-end: span ${props.span.mobile};
    }
  `}
`;

GridCell.defaultProps = {
  span: {
    desktop: 1,
  },
};

export {
  Grid,
  GridCell,
};
